import _ from 'lodash';
import {
    LOGIN,
    NEWS_CREATE,
    NEWS_UPDATE,
    GROUP_LIST_PAGE_LOADED,
    LOG_LIST_PAGE_LOADED
} from '../constants/actionTypes'

let roles = {
    master_admin: {
        id: 1000,
        can: [LOGIN]
    },
    admin: {
        id: 999,
        can: [LOGIN]
    },
    cert_admin: {
        id: 300,
        can: [
            LOGIN
        ]
    },
    file_admin: {
        id: 100,
        can: [
            LOGIN,
            GROUP_LIST_PAGE_LOADED,
            LOG_LIST_PAGE_LOADED
        ]
    },
    user: {
        id: 0,
        can: [
            // LOGIN
        ]
    },
    merchant: {
        id: 1,
        can: []
    },
}

// extend role to inherit other roles permissions
// roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_id_approver.can);
// roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_bank_verifier.can);
// roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_bank_chat.can);

export default {
    isAdmin: function (roleId) {
        return roleId === roles.admin.id
    },
    isMerchant: function (roleId) {
        return roleId === roles.merchant.id
    },
    isCertAdmin: function (roleId) {
        return roleId === roles.master_admin.id || roleId === roles.admin.id || roleId === roles.cert_admin.id
    },
    isFileAdmin: function (roleId) {
        return roleId === roles.master_admin.id || roleId === roles.admin.id || roleId === roles.file_admin.id
    },
    can(role, operation) {
        if (this.isAdmin(role))
            return true;
        let matchingRole = _.filter(roles, function (o) { return o.id === role; });
        return matchingRole[0] && matchingRole[0].can.indexOf(operation) !== -1;
    }
}
